import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import userApi from "service/userApi";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import CuaHangDoiTacApi from "service/cuaHangDoiTacApi";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";

export const ModalSearchNangCaoMobileXuatHoaDon = ({
  dataSearch,
  onChange,
  onSearch,
  onHide,
  show,
  isHoaHongTraGop,
}) => {
  const initKieuVay = [
    { value: "0", label: "Tất cả" },
    { value: "3", label: "Cầm đồ" },
    { value: "1", label: "Tín chấp" },
    { value: "2", label: "Trả góp" },
    { value: "4", label: "Nhận Vay" },
    { value: "5", label: "Bán hàng trả góp" },
  ];
  const [dataKieuVay] = useState(initKieuVay);
  const [nguonkhachhang, setNgonKhachHang] = useState([
    { label: "Tất cả", value: 0 },
  ]);
  const [lstTinhTrangNo, setLstTinhTrangNo] = useState([]);
  const [listUser, setListUser] = useState([]);

  useEffect(() => {
    userApi.combo().then((response) => {
      setListUser(
        response.data.map((item) => ({ value: item.value, label: item.label })),
      );
    });
    CuaHangDoiTacApi.combo().then((response) => {
      setNgonKhachHang(
        response.data.map((item) => ({ value: item.value, label: item.label })),
      );
    });
    DoiTinhTrangNoApi.getListTinhTrangNo().then((response) => {
      if (response.status === 200) {
        setLstTinhTrangNo([
          { value: "-1", label: "Tất cả" },
          ...response.data.map((item) => ({
            value: item.Code,
            label: item.Name,
          })),
        ]);
      }
    });
  }, []);

  const updateField = (field) => (e) => onChange(field, e.target.value);
  const onChangeDate = (field) => (evt) => onChange(field, formatDayMonth(evt));

  const handleSearch = () => {
    onHide();
    onSearch();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") handleSearch();
  };

  var tuNgay = currentDate();
  if (dataSearch.tuNgay === "01/01/2001") tuNgay = "";
  else tuNgay = dataSearch.tuNgay;
  var denNgay = currentDate();
  if (dataSearch.denNgay === "01/01/4000") denNgay = "";
  else denNgay = dataSearch.denNgay;
  denNgay = convertDate(denNgay);
  tuNgay = convertDate(tuNgay);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-file-search"></i>
          </span>{" "}
          Tìm kiếm nâng cao
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="row repeater-default">
            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label>Từ ngày</label>
              <br />
              <DateTimePicker
                value={tuNgay}
                onChange={onChangeDate("tuNgay")}
                placeholder="Từ ngày"
                name="tuNgay"
              />
            </div>
            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label>Đến ngày</label>
              <br />
              <DateTimePicker
                value={denNgay}
                onChange={onChangeDate("denNgay")}
                placeholder="Đến ngày"
                name="denNgay"
              />
            </div>
            {/* <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label>Nhân viên</label>
              <select
                name="nhanvien"
                className="selectBox form-control input-sm"
                value={dataSearch.nhanvien}
                onChange={updateField("nhanvien")}
              >
                {listUser.map((item, idx) => (
                  <option key={idx} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div> */}
            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3 col-12">
              <label>Kiểu vay</label>
              <select
                name="kieuvay"
                className="selectBox form-control input-sm"
                value={dataSearch.kieuvay}
                onChange={updateField("kieuvay")}
              >
                {dataKieuVay.map((item, idx) => (
                  <option key={idx} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3 col-12">
              <label>Trạng thái</label>
              <select
                name="trangThaiHoaDon"
                className="selectBox form-control input-sm"
                value={dataSearch.trangThaiHoaDon}
                onChange={updateField("trangThaiHoaDon")}
              >
                <option value={-2}>Tất cả</option>
                <option value={0}>Chờ xuất</option>
                <option value={1}>Đã xuất</option>
                <option value={2}>Bản nháp</option>
                <option value={-1}>Hủy</option>
              </select>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <a
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={handleSearch}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-magnify"></i>
          </span>
          Tìm kiếm
        </a>
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
